import React, { FC, ReactNode } from 'react'
import './Wrapper.scss'
import Sidebar from '../../../Layout/Auth/Sidebar/Sidebar'
import { Footer, Navbar } from '../../../Layout/Auth'
import { useIdleTimer } from 'react-idle-timer'

interface propsType {
 children: ReactNode
}
const Wrapper:FC<propsType> = ({ children }) => {
  const onPrompt = () => {
    // Fire a Modal Prompt
  }

  const onIdle = () => {
    // Close Modal Prompt
    // Do some idle action like log out your user
    logout()
  }

  const onActive = (event: any) => {
    // Close Modal Prompt
    // Do some active action
  }

  const onAction = (event: any) => {
    // Do something when a user triggers a watched event
  }

  const logout = () => {
    localStorage.removeItem('__session_polac_physical')
    window.location.replace('/login')
  }

  useIdleTimer({
    onPrompt,
    onIdle,
    onActive,
    onAction,
    timeout: 1000 * 60 * 20,
    promptTimeout: 0,
    events: [
      'mousemove',
      'keydown',
      'wheel',
      'DOMMouseScroll',
      'mousewheel',
      'mousedown',
      'touchstart',
      'touchmove',
      'MSPointerDown',
      'MSPointerMove',
      'visibilitychange'
    ],
    immediateEvents: [],
    debounce: 0,
    throttle: 0,
    eventsThrottle: 200,
    element: document,
    startOnMount: true,
    startManually: false,
    stopOnIdle: false,
    crossTab: false,
    name: 'idle-timer',
    syncTimers: 0,
    leaderElection: false
  })

  return (
    <div className="page-wrapper">
      <Navbar></Navbar>
        <div className="main-container">
            <div className="sidebar d-none">
               <Sidebar></Sidebar>
            </div>
            <div className="content">
              {children}
            </div>

        </div>
        <Footer></Footer>
    </div>
  )
}

export default Wrapper
